jQuery(document).ready(function ($){

    $( '.timepicker input' ).timepicker({
        timeFormat: 'HH:mm',
        interval: 15,
        startTime: '08:00',
        dynamic: false,
        dropdown: true,
        scrollbar: true
    });

});